module.exports = __webpack_public_path__ + "static/media/mnożenie_i_dzielenie_w_zakresie_20.16739962.pdf";